<template>
  <div>
    <!-- Background banner disabled per Ofir's redesign request. -->
    <!-- <Banner v-if="bannerImages.length >0" :imageList="bannerImages" type="search-result" /> -->
    <SearchTabs />

    <InforStrip :count="searchResultCount" :destination="isMultiSearchDate ? destinationCityName(firstDest) : destinationCityName(activeDestDates)" :date="dateString"/>

    <MobileFilter
      :sortButtonList="mobileSortButtonList"
      @updateSort="doSort"
      @filterChange="filterByOption"
      :filterOptions="filterOptions"
      isHome="searchResult"
    />
    <SearchPopup />

    <div class="my-5 sportspage_area" :class="isRTLPage ? 'right-align' : 'left-align'">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-12 sideBar desktop_form">
            <filter-panel
              v-if="!isLoading"
              :options="filterOptions"
              @change="filterByOption"
            />
          </div>
          <!--
            Streaming v2 branch (feature-flagged in TemplateSearchResult.js).
            When useStreamingSearch is TRUE, this block wins and the three original
            "loading / timeout / results" states become v-else-if / v-else — dead code
            for this render. Flip the flag off to restore the original behaviour without
            touching anything else.
          -->
          <div class="col-lg-9 col-12 filter-cont package-organize" v-if="useStreamingSearch">
            <!--
              On mobile the productions toggle sits ABOVE the progress bar
              (per Ofir 2026-08-16) so the very first thing the user sees on
              a results screen is the "לחץ להצגת הפקות" affordance. On desktop
              it stays in its usual place next to the sort buttons below.
            -->
            <div v-if="device === 'mobile'" class="productions-toggle-mobile-wrap">
              <button
                type="button"
                class="productions-toggle"
                :class="{ 'is-open': showProductions }"
                @click="showProductions = !showProductions"
              >
                <span class="productions-toggle__caret" aria-hidden="true">
                  {{ showProductions ? '▲' : '▼' }}
                </span>
                {{ showProductions ? 'הסתר הפקות, חופשות והופעות' : 'לחץ להצגת הפקות, חופשות והופעות' }}
              </button>
              <a
                class="irgun-morim-link"
                href="https://irgon.flyingcarpet.co.il/agent"
                target="_blank"
                rel="noopener noreferrer"
              >הזמנות ארגון המורים</a>
              <ProductionsGrid
                v-if="showProductions"
                :items="productionsItems"
                :loading="productionsLoading"
              />
            </div>
            <SearchProgressBar />
            <SupplierProgressChips />
            <div v-if="!streamingHasFirstResult" class="text-center">
              <ContentLoading type="search-result"/>
            </div>
            <template v-else>
              <div class="desktop_form my-3">
                <h3>
                  {{ $t("search-result.goa") }}: {{ searchResultCount }}
                  {{ $t("search-result.properties-found") }} : {{ destinationCityName(firstDest) }}, {{ dateString }}
                </h3>
                <hr />
                <!--
                  Row that holds the sort buttons (price low→high / high→low)
                  AND the productions toggle side-by-side. Desktop only — on
                  mobile the toggle already rendered above the progress bar.
                -->
                <div class="sort-with-productions-toggle">
                  <SortButtons :buttonList="sortButtonList" @updateSort="doSort" :chainList="hotelChainListOption.subItems"/>
                  <button
                    v-if="device !== 'mobile'"
                    type="button"
                    class="productions-toggle"
                    :class="{ 'is-open': showProductions }"
                    @click="showProductions = !showProductions"
                  >
                    <span class="productions-toggle__caret" aria-hidden="true">
                      {{ showProductions ? '▲' : '▼' }}
                    </span>
                    {{ showProductions ? 'הסתר הפקות, חופשות והופעות' : 'לחץ להצגת הפקות, חופשות והופעות' }}
                  </button>
                  <a
                    v-if="device !== 'mobile'"
                    class="irgun-morim-link"
                    href="https://irgon.flyingcarpet.co.il/agent"
                    target="_blank"
                    rel="noopener noreferrer"
                  >הזמנות ארגון המורים</a>
                </div>
                <!-- Productions grid — desktop rendering. Mobile grid is
                     mounted above alongside its own toggle. -->
                <ProductionsGrid
                  v-if="showProductions && device !== 'mobile'"
                  :items="productionsItems"
                  :loading="productionsLoading"
                />
              </div>
              <!-- Club Hotels is not one of our suppliers: these open the operator's own availability
                   page with the stay already entered here. Link only — no prices, no booking. Rendered
                   in the streaming v2 branch too — the legacy branch renders the same block under b-tabs. -->
              <div v-if="clubHotelsLinks.length" class="club-hotels">
                <span class="club-hotels__label">בדיקת זמינות ישירות באתר קלאב הוטל — קישור בלבד, ללא מחירים וללא הזמנה</span>
                <span class="club-hotels__links">
                  <a
                    v-for="link in clubHotelsLinks"
                    :key="link.href"
                    :href="link.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="club-hotels__link"
                  >{{ link.text }}</a>
                </span>
              </div>
              <!--
                Render filteredHotel (not streamedProcessedHotels directly). The watcher on
                streamedProcessedHotels seeds this.hotels + this.filteredHotel; sidebar
                filters (filterByOption) and sort (doSort) mutate filteredHotel so the list
                stays in sync with user filter toggles.
              -->
              <FilterItem
                v-for="(item, inx) in filteredHotel"
                :key="`stream-${item.supplierCode}-${item.exCode}-${item.category || ''}-${inx}`"
                :hotel="item"
                :itemIndex="inx"
                :sortedReset="sortedReset"
              />
            </template>
          </div>

          <div class="col-lg-9 col-12 filter-cont package-organize" v-else-if="isLoadingMulti && !timerEnd">
            <h3 class="text-center">{{ $t("search-result.just-another-moment") }}</h3>
            <div class="content text-center">
              <h3>{{ $t("search-result.domestic-search.search-loading-text2", {destinationName: destinationCityName(firstDest)})}}</h3>
            </div>
            <div class="circle" style="display: flex; justify-content: center; margin : auto">{{countDown}}</div>
            <h3 class="text-center">{{ $t("search-result.seconds") }}</h3>
            <ContentLoading type="search-result"/>
          </div>
          <div class="col-lg-9 col-12 filter-cont package-organize" v-else-if="isLoadingMulti && timerEnd">
            <div class="content text-center">
              <h3>{{ $t("search-result.domestic-search.search-loading-time-end", {
                destinationName: isMultiSearchDate ? destinationCityName(firstDest) : destinationCityName(activeDestDates)
              })}}</h3>
            </div>
            <ContentLoading type="search-result"/>
          </div>

          <div class="col-lg-9 col-12 filter-cont package-organize" v-else>
            <div class="desktop_form my-3">
              <h3>
                {{ $t("search-result.goa") }}: {{ searchResultCount }}
                {{ $t("search-result.properties-found") }} : {{
                  isMultiSearchDate ? destinationCityName(firstDest) : destinationCityName(activeDestDates)
                }}, {{ dateString }}
              </h3>
              <hr />
              <SortButtons :buttonList="sortButtonList" @updateSort="doSort" :chainList="hotelChainListOption.subItems"/>
            </div>
           <b-tabs v-model="tabIndex" :class="!isMultiSearchCase && 'none-multiple-search'">
              <b-tab class="my-3" v-for="(dateDest, index) in (isMultiSearchDate ? listDateKeys : listDests)"
                :key="index" :active="index===tabIndex"
                @click=" ev => changeTab(index)" >
                <template #title>
                  <div class="tab-title"><p>{{ isMultiSearchDate ? dateDest : destinationCityName(dateDest) }}</p></div>
                </template>
                <b-card-text>
                  <!-- Club Hotels is not one of our suppliers: these open the operator's own availability
                       page with the stay already entered here. Link only — no prices, no booking. -->
                  <div v-if="clubHotelsLinks.length" class="club-hotels">
                    <span class="club-hotels__label">בדיקת זמינות ישירות באתר קלאב הוטל — קישור בלבד, ללא מחירים וללא הזמנה</span>
                    <span class="club-hotels__links">
                      <a
                        v-for="link in clubHotelsLinks"
                        :key="link.href"
                        :href="link.href"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="club-hotels__link"
                      >{{ link.text }}</a>
                    </span>
                  </div>

                  <FilterItem v-for="(item, inx) in filteredHotel" :key="inx" :hotel="item" :itemIndex="inx" :sortedReset="sortedReset"/>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <Footer page="search" v-if="!hideFooter"/>
  </div>
</template>

<script>
import { BTabs, BTab, BCardText } from 'bootstrap-vue';
import TemplateSearchResult from './TemplateSearchResult';
import ProductionsGrid from '@/components/productions/ProductionsGrid';

export default {
  name: 'SearchResultTheme0',
  mixins: [TemplateSearchResult],
  components: {
    BTabs,
    BTab,
    BCardText,
    // Banner removed per redesign; keep import commented for easy revert.
    // Banner: () => import('@/components/content/Banner'),
    SearchTabs: () => import('@/components/search/searchTabs/SearchTabsTheme0'),
    InforStrip: () => import('@/components/searchResult/InforStrip'),
    SupplierProgressChips: () => import('@/components/searchResult/SupplierProgressChips'),
    SearchProgressBar: () => import('@/components/search/SearchProgressBar'),
    // SidebarFilterSlide: () => import('@/components/searchResult/atoms/SidebarFilterSlide'),
    FilterPanel: () => import('@/components/searchResult/atoms/FilterPanel'),
    MobileFilter: () => import('@/components/searchResult/MobileFilter'),
    SearchPopup: () => import('@/components/searchResult/SearchPopup'),
    // SearchTab: () => import('@/components/search/SearchTab'),
    FilterItem: () => import('@/components/searchResult/atoms/filterItem/FilterItemTheme0'),
    SortButtons: () => import('@/components/searchResult/atoms/SortButtons'),
    ContentLoading: () => import('@/components/atoms/ContentLoading'),
    Footer: () => import('@/components/content/footer/FooterTheme0'),
    ProductionsGrid,
  },
  data() {
    return {
      // Productions grid is hidden by default on the results page; the toggle
      // button under the supplier chips flips this on demand.
      showProductions: false,
    };
  },
  computed: {
    productionsItems() { return this.$store.getters.GET_PRODUCTIONS || []; },
    productionsLoading() {
      return this.$store.getters.GET_PRODUCTIONS_LOADING
        && !this.$store.getters.GET_PRODUCTIONS;
    },
  },
  mounted() {
    // Fires only if HomeTheme didn't already populate the cache — but the
    // action is idempotent (uses ETag → 304 short-circuit) so a duplicate
    // dispatch on landing straight into results is safe and free.
    this.$store.dispatch('FETCH_PRODUCTIONS');
  },
};
</script>

<style scoped>
.club-hotels {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  background: #fff;
}
.club-hotels__label {
  font-size: 13px;
  font-weight: 600;
  color: #6b6b6b;
}
.club-hotels__links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.club-hotels__link {
  display: inline-block;
  padding: 7px 14px;
  border: 1px solid #d2dff0;
  border-radius: 8px;
  background: #fff;
  color: #0f6cbd;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}
.club-hotels__link:hover {
  background: #eaf1fb;
  text-decoration: none;
}
/* Productions toggle sits IMMEDIATELY next to the sort buttons (price
   low↔high) — not on the opposite edge of the row. In this RTL context
   the sort buttons are visually on the right, so justify-content: flex-start
   packs both to the right and lets the toggle land right beside them with
   a small gap. `flex: 0 0 auto` on the SortButtons wrapper keeps it from
   stretching and pushing the toggle away. */
.sort-with-productions-toggle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}
.sort-with-productions-toggle > *:first-child {
  flex: 0 0 auto;
}
.productions-toggle {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  border-radius: 999px;
  border: 1px solid #f3a75a;
  background: #f3a75a;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
}
.productions-toggle:hover {
  background: #e08d3f;
  border-color: #e08d3f;
}
.productions-toggle.is-open {
  background: #ffffff;
  color: #1f4c96;
  border-color: #1f4c96;
}
.productions-toggle.is-open:hover {
  background: #eef4fb;
}
.productions-toggle__caret {
  font-size: 10px;
  line-height: 1;
}
/* Red pill-link to the Irgun HaMorim (teachers' union) agent portal — opens
   in a new tab. Same shape/padding as .productions-toggle so it sits next
   to it evenly. */
.irgun-morim-link {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  border-radius: 999px;
  border: 1px solid #d9534f;
  background: #d9534f;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}
.irgun-morim-link:hover,
.irgun-morim-link:focus {
  background: #c9302c;
  border-color: #c9302c;
  color: #ffffff;
  text-decoration: none;
}
@media (max-width: 767px) {
  .sort-with-productions-toggle {
    justify-content: flex-start;
  }
  .productions-toggle {
    width: 100%;
    justify-content: center;
  }
  .irgun-morim-link {
    width: 100%;
    justify-content: center;
    margin-top: 6px;
  }
  /* Mobile productions wrap — sits above <SearchProgressBar>. Padding
     keeps the button off the container edges. */
  .productions-toggle-mobile-wrap {
    padding: 6px 8px 4px;
  }
}

.tab-title {
  color: black;
  font-weight: 900;
  font-size: large;
}
a.active .tab-title {
  color: white;
}
.sportspage_area {
  direction: rtl !important;
}
.left-align .package-organize {
  direction: ltr;
  text-align: left;
}
@media (max-width: 479px) {
  .sportspage_area {
    margin: 0 !important;
  }
}
</style>

<style>
.filter-hotel .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  right: -0.5rem;
}

.dVacation-pack.filter-cont .filterItem:not(:first-child) {
  margin-top: 0px;
}

.modal.show .modal-dialog.noSearchResult {
  display: inline-block;
  top: calc(50vh - 100px);
}

.modal-dialog.noSearchResult .modal-body{
  text-align: center;
}

.content {
  font-size:  20px;
}

.circle {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  font-size: 32px;
  color: #fff;
  text-align: center;
  background: red;
}

.package-organize .tab-content {
  border: none;
}

.package-organize .nav-tabs .nav-link.active {
  color: #fff;
  background-color: #005fa8;
}

.none-multiple-search ul.nav.nav-tabs {
  display: none;
}
@media (max-width: 479px) {
  .modal.show .modal-dialog.noSearchResult {
    display: flex;
    left: -10px;
    top: unset;
  }

  .content h3 {
    font-size: 20px !important;
  }

  .circle {
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    font-size: 20px;
    color: #fff;
    text-align: center;
    background: red;
  }
}
</style>
